module.exports = __webpack_public_path__ + "static/media/MATIC.040f1bcd.svg";